import { ContextMenuComponent } from './components/contextmenu.component/contextmenu.component';

const menus: Record<string, typeof ContextMenuComponent> = {};

function register(name: string, menu: unknown) {
    if (menus[name]) {
        throw new Error(`ContextMenu "${name}" was already registered.`);
    }

    menus[name] = menu as typeof ContextMenuComponent;
}

function unregister(name: string) {
    if (menus[name]) {
        delete menus[name];
    }
}

const contextMenuManager = {
    menus,
    register,
    unregister,
};

export { contextMenuManager };
